import { type Ref, ref } from 'vue'

import type {
    BoxType,
    CampaignForShippingLabel,
    Country,
    CustomerAddress,
    EcommerceOrderForShippingLabel,
    PackageType,
    ShippingLabelDestination,
    ShippingLabelDetails,
    ShippingLabelListItem,
    ShippingLabelStatus,
    ShippingLabelTemplate,
    ShippingLabelType,
    ShippingLabelsFilters,
    ShippingOrderForShippingLabel
} from '@/api/schemas/shipments/shippingLabels'

export function createInitialFilters(): ShippingLabelsFilters {
    return {
        type_id: null,
        status_id: null,
        number: null,
        customer_name: null,
        source_object_number: null
    }
}

export function createShippingLabelsState(): {
    shippingLabels: Ref<ShippingLabelListItem[]>
    shippingLabelsLoading: Ref<boolean>
    shippingLabel: Ref<ShippingLabelDetails | null>
    shippingLabelLoading: Ref<boolean>
    shippingLabelStatuses: Ref<ShippingLabelStatus[]>
    shippingLabelStatusesLoading: Ref<boolean>
    shippingLabelTypes: Ref<ShippingLabelType[]>
    shippingLabelTypesLoading: Ref<boolean>
    shippingLabelTemplates: Ref<ShippingLabelTemplate[]>
    shippingLabelTemplatesLoading: Ref<boolean>
    shippingLabelDestinations: Ref<ShippingLabelDestination[]>
    shippingLabelDestinationsLoading: Ref<boolean>
    shippingOrdersForShippingLabels: Ref<ShippingOrderForShippingLabel[]>
    shippingOrdersForShippingLabelsLoading: Ref<boolean>
    ecommerceOrdersForShippingLabels: Ref<EcommerceOrderForShippingLabel[]>
    ecommerceOrdersForShippingLabelsLoading: Ref<boolean>
    campaignsForShippingLabels: Ref<CampaignForShippingLabel[]>
    campaignsForShippingLabelsLoading: Ref<boolean>
    boxTypes: Ref<BoxType[]>
    boxTypesLoading: Ref<boolean>
    packageTypes: Ref<PackageType[]>
    packageTypesLoading: Ref<boolean>
    countries: Ref<Country[]>
    countriesLoading: Ref<boolean>
    customerAddresses: Ref<CustomerAddress[]>
    customerAddressesLoading: Ref<boolean>
    filters: Ref<ShippingLabelsFilters>
} {
    return {
        shippingLabels: ref<ShippingLabelListItem[]>([]),
        shippingLabelsLoading: ref(false),
        shippingLabel: ref<ShippingLabelDetails | null>(null),
        shippingLabelLoading: ref(false),
        shippingLabelStatuses: ref<ShippingLabelStatus[]>([]),
        shippingLabelStatusesLoading: ref(false),
        shippingLabelTypes: ref<ShippingLabelType[]>([]),
        shippingLabelTypesLoading: ref(false),
        shippingLabelTemplates: ref<ShippingLabelTemplate[]>([]),
        shippingLabelTemplatesLoading: ref(false),
        shippingLabelDestinations: ref<ShippingLabelDestination[]>([]),
        shippingLabelDestinationsLoading: ref(false),
        shippingOrdersForShippingLabels: ref<ShippingOrderForShippingLabel[]>([]),
        shippingOrdersForShippingLabelsLoading: ref(false),
        ecommerceOrdersForShippingLabels: ref<EcommerceOrderForShippingLabel[]>([]),
        ecommerceOrdersForShippingLabelsLoading: ref(false),
        campaignsForShippingLabels: ref<CampaignForShippingLabel[]>([]),
        campaignsForShippingLabelsLoading: ref(false),
        boxTypes: ref<BoxType[]>([]),
        boxTypesLoading: ref(false),
        packageTypes: ref<PackageType[]>([]),
        packageTypesLoading: ref(false),
        countries: ref<Country[]>([]),
        countriesLoading: ref(false),
        customerAddresses: ref<CustomerAddress[]>([]),
        customerAddressesLoading: ref(false),
        filters: ref<ShippingLabelsFilters>(createInitialFilters())
    }
}

export type ShippingLabelsState = ReturnType<typeof createShippingLabelsState>
